export * from "./grupodeproduto-edit.component";
export * from "./grupodeproduto-browse.component";
